import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import Moment from "moment";

import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "moment/locale/es";

import { LOCALE } from "./config/locale";

import App from "./App";
import reducers from "./reducers";

Moment.locale(LOCALE);

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector("#root")
);
